export const getReview = (attemptData: any, attempt: string | number) => {
    if (attempt === "manual") {
        return attemptData?.review || [];
    }
    return attemptData?.lastReview?.review || [];
}
